<template>
  <Swiper
    :space-between="10"
    slides-per-view="auto"
    free-mode
    :mousewheel="{forceToAxis: true}"
    :modules="[SwiperFreeMode, SwiperMousewheel]"
  >
    <SwiperSlide class="!w-fit">
      <button
        class="btn text-blue select-none whitespace-nowrap border capitalize duration-300"
        :class="{'bg-blue': selection === 0, 'text-white': selection === 0}"
        :value="undefined"
        @click="selectAmbition"
      >
        {{ $t('All') }}
      </button>
    </SwiperSlide>

    <SwiperSlide
      v-for="ambition in ambitions"
      :key="ambition.id"
      class="!w-fit"
    >
      <AmbitionButton
        :ambition="ambition"
        :selected="selection === ambition.id"
        :value="ambition.id"
        @click="selectAmbition"
      />
    </SwiperSlide>
  </Swiper>
</template>

<script setup lang="ts">
import type {AmbitionsQuery} from '~/graphql/graphql';

withDefaults(defineProps<{
  ambitions: AmbitionsQuery['ambitions']
  selection?: number
}>(), {
  ambitions: () => [],
  selection: undefined,
});

const emit = defineEmits<{
  (e: 'update:selection', selected: number | undefined): void
}>();

const selectAmbition = (event: MouseEvent | TouchEvent) => {
  emit('update:selection', parseInt((event.target as HTMLInputElement).value) || undefined);
};
</script>
